import React from "react";
import { Helmet } from "react-helmet-async";
import { Landing } from "../components/private/index.js";
import { Footer, Navbar, } from "../components/shared";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள்</title>
        <meta
          name="description"
          content="ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் !"
        />
        <link rel="manifest" href="/manifest.json" />
        <link rel="icon" href="../../assets/pictures/favicon.png" />
        <link rel="canonical" href="/" />
      </Helmet>
      <Navbar />
      <Landing />
      <Footer />
    </>
  );
};

export default Home;
